import React, { useState, useEffect } from 'react';

const VendorStatusPage = () => {
  const [statusData, setStatusData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchVendorData = async () => {
      try {
        // Get the authentication token from localStorage or sessionStorage
        // This assumes you're storing the token after login
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        
        if (!token) {
          throw new Error('Authentication token not found');
        }
        
        const response = await fetch('http://203.161.55.192:8086/vservice/api/v1/auth/profile', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` // Include token in Authorization header
          }
        });
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        
        const data = await response.json();
        setStatusData(data);
      } catch (err) {
        setError('Failed to fetch vendor data. Please try again later.');
        console.error('Error fetching data:', err);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchVendorData();
  }, []);
  
  // Custom CSS styles
  const styles = {
    pageContainer: {
      margin: '0 auto',
      fontFamily: '"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      color: '#2d3748',
      background: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)',
      padding: '20px',
    },
    header: {
      textAlign: 'center',
      marginBottom: '40px',
    },
    title: {
      fontSize: '32px',
      fontWeight: '800',
      marginBottom: '16px',
      color: '#1a365d',
      letterSpacing: '-0.025em',
    },
    subtitle: {
      fontSize: '18px',
      color: '#4a5568',
      maxWidth: '500px',
      margin: '0 auto',
      lineHeight: '1.5',
    },
    statusContainer: {
      textAlign: 'center',
      padding: '30px',
      borderRadius: '12px',
      marginBottom: '30px',
      transition: 'all 0.3s ease',
    },
    successfulContainer: {
      background: 'linear-gradient(135deg, #E6FFFA 0%, #B2F5EA 100%)',
      border: '2px solid #38B2AC',
    },
    pendingContainer: {
      background: 'linear-gradient(135deg, #fdd212 0%, #fdd212 100%)',
      border: '2px solid #fdd212',
    },
    rejectedContainer: {
      background: 'linear-gradient(135deg, #FFF5F5 0%, #FED7D7 100%)',
      border: '2px solid #F56565',
    },
    expiredContainer: {
      background: 'linear-gradient(135deg, #EDF2F7 0%, #CBD5E0 100%)',
      border: '2px solid #718096',
    },
    statusIcon: {
      width: '80px',
      height: '80px',
      margin: '0 auto 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      background: 'rgba(255, 255, 255, 0.85)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    },
    statusTitle: {
      fontSize: '25px',
      fontWeight: '700',
      marginBottom: '10px',
      color: '#000',
    },
    statusMessage: {
      fontSize: '16px',
      lineHeight: '1.6',
      marginBottom: '20px',
    },
    statusDetails: {
      background: 'rgba(255, 255, 255, 0.6)',
      borderRadius: '8px',
      padding: '15px 20px',
      marginTop: '25px',
      display: 'inline-block',
      textAlign: 'left',
    },
    detailItem: {
      display: 'flex',
      margin: '8px 0',
      alignItems: 'center',
    },
    detailLabel: {
      fontWeight: '600',
      marginRight: '10px',
      color: '#4A5568',
      minWidth: '170px',
    },
    detailValue: {
      color: '#1A202C',
    },
    progressTracker: {
      margin: '40px 0',
    },
    progressContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      marginBottom: '50px',
    },
    progressLine: {
      position: 'absolute',
      top: '15px',
      left: '7%',
      right: '7%',
      height: '4px',
      background: '#E2E8F0',
      zIndex: '1',
    },
    progressActive: {
      background: '#38B2AC',
      height: '100%',
      transition: 'width 0.5s ease',
    },
    progressStep: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      zIndex: '5',
      width: '33.333%',
    },
    progressDot: {
      width: '36px',
      height: '36px',
      borderRadius: '50%',
      background: '#E2E8F0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '10px',
      fontWeight: '600',
      color: '#718096',
      border: '2px solid white',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      transition: 'all 0.3s ease',
    },
    progressDotActive: {
      background: '#4299E1',
      color: 'white',
    },
    progressDotComplete: {
      background: '#38A169',
      color: 'white',
    },
    progressLabel: {
      fontSize: '14px',
      fontWeight: '500',
      textAlign: 'center',
      color: '#718096',
      transition: 'all 0.3s ease',
    },
    progressLabelActive: {
      color: '#2D3748',
      fontWeight: '600',
    },
    supportSection: {
      marginTop: '40px',
      padding: '25px',
      background: '#F7FAFC',
      borderRadius: '10px',
      border: '1px solid #E2E8F0',
    },
    supportTitle: {
      fontSize: '18px',
      fontWeight: '600',
      marginBottom: '15px',
      color: '#2D3748',
    },
    supportText: {
      fontSize: '15px',
      lineHeight: '1.6',
      color: '#4A5568',
      marginBottom: '20px',
    },
    contactMethods: {
      display: 'flex',
      justifyContent: 'center',
      gap: '20px',
      flexWrap: 'wrap',
    },
    contactMethod: {
      display: 'flex',
      alignItems: 'center',
      padding: '10px 15px',
      background: 'white',
      borderRadius: '8px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
      fontSize: '14px',
      color: '#4A5568',
    },
    contactIcon: {
      marginRight: '8px',
      color: '#4299E1',
    },
    loadingSpinner: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '50px 0',
    },
    spinnerCircle: {
      width: '60px',
      height: '60px',
      border: '4px solid rgba(0, 0, 0, 0.1)',
      borderTopColor: '#4299E1',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
    '@keyframes spin': {
      to: { transform: 'rotate(360deg)' },
    },
    loadingText: {
      marginTop: '15px',
      color: '#4A5568',
      fontSize: '16px',
    },
    errorContainer: {
      textAlign: 'center',
      padding: '40px 20px',
      color: '#E53E3E',
    },
    servicesBadge: {
      display: 'inline-block',
      background: '#EBF8FF',
      color: '#3182CE',
      borderRadius: '16px',
      padding: '5px 12px',
      fontSize: '14px',
      margin: '5px',
      border: '1px solid #BEE3F8',
    },
    servicesContainer: {
      marginTop: '15px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
    }
  };

  // Handle loading state
  if (isLoading) {
    return (
      <div style={styles.pageContainer}>
        <div style={styles.loadingSpinner}>
          <div style={styles.spinnerCircle}></div>
          <p style={styles.loadingText}>Loading your business status...</p>
        </div>
      </div>
    );
  }

  // Handle error state
  if (error || !statusData) {
    return (
      <div style={styles.pageContainer}>
        <div style={styles.errorContainer}>
          <h1 style={{fontSize: '24px', marginBottom: '15px'}}>Error</h1>
          <p>{error || "We couldn't retrieve your business information. Please try again later."}</p>
        </div>
      </div>
    );
  }

  // Determine progress based on status
  let progress = {
    step: 1,
    width: '33%'
  };
  
  if (statusData.businessStatus === 'PENDING') {
    progress.step = 2;
    progress.width = '66%';
  } else if (statusData.businessStatus === 'SUCCESSFUL') {
    progress.step = 3;
    progress.width = '100%';
  }

  // Get container style based on business status
  const getContainerStyle = () => {
    if (statusData.businessStatus === 'SUCCESSFUL') {
      return {...styles.statusContainer, ...styles.successfulContainer};
    } else if (statusData.businessStatus === 'REJECTED') {
      return {...styles.statusContainer, ...styles.rejectedContainer};
    } else if (statusData.businessStatus === 'PENDING') {
      return {...styles.statusContainer, ...styles.pendingContainer};
    } else {
      return {...styles.statusContainer, ...styles.expiredContainer};
    }
  };

  // Get status title and message based on business status
  const getStatusInfo = () => {
    switch(statusData.businessStatus) {
      case 'SUCCESSFUL':
        return {
          title: 'Business Registration Successful!',
          message: 'Congratulations! Your business registration has been approved and is now active.',
          icon: (
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2C7A7B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          )
        };
      case 'PENDING':
        return {
          title: 'Registration In Progress',
          message: 'Your business registration is currently being processed. This usually takes 1-2 business days.',
          icon: (
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2B6CB0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          )
        };
      case 'REJECTED':
        return {
          title: 'Registration Needs Attention',
          message: 'We found some issues with your business registration that need to be addressed. Please check your email for details or contact our support team.',
          icon: (
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#C53030" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
          )
        };
      default:
        return {
          title: 'Status Unavailable',
          message: 'The status of your business registration is currently unavailable. Please contact support for assistance.',
          icon: (
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#718096" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          )
        };
    }
  };

  const statusInfo = getStatusInfo();

  // Format dates for display
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <div style={styles.pageContainer}>
      <div style={styles.header}>
        <h1 style={styles.title}>Business Status</h1>
        <p style={styles.subtitle}>
          View the current status of your business registration and subscription details.
        </p>
      </div>

      <div style={getContainerStyle()}>
        <div style={styles.statusIcon}>
          {statusInfo.icon}
        </div>
        
        <h2 style={styles.statusTitle}>{statusInfo.title}</h2>
        <p style={styles.statusMessage}>{statusInfo.message}</p>

        <div style={styles.statusDetails}>
          <div style={styles.detailItem}>
            <span style={styles.detailLabel}>Business Name:</span>
            <span style={styles.detailValue}>{statusData.businessName}</span>
          </div>
          <div style={styles.detailItem}>
            <span style={styles.detailLabel}>Business Phone:</span>
            <span style={styles.detailValue}>{statusData.businessPhoneNumber}</span>
          </div>
          <div style={styles.detailItem}>
            <span style={styles.detailLabel}>Owner:</span>
            <span style={styles.detailValue}>{`${statusData.firstName} ${statusData.otherName}`}</span>
          </div>
          <div style={styles.detailItem}>
            <span style={styles.detailLabel}>Email:</span>
            <span style={styles.detailValue}>{statusData.email}</span>
          </div>
          <div style={styles.detailItem}>
            <span style={styles.detailLabel}>Phone Number:</span>
            <span style={styles.detailValue}>{statusData.phoneNumber}</span>
          </div>
          <div style={styles.detailItem}>
            <span style={styles.detailLabel}>Subscription Type:</span>
            <span style={styles.detailValue}>{statusData.subscriptionType}</span>
          </div>
          <div style={styles.detailItem}>
            <span style={styles.detailLabel}>Subscription Status:</span>
            <span style={styles.detailValue}>{statusData.subscriptionStatus}</span>
          </div>
          <div style={styles.detailItem}>
            <span style={styles.detailLabel}>Total Amount:</span>
            <span style={styles.detailValue}>GH₵ {statusData.totalAmount.toFixed(2)}</span>
          </div>
          <div style={styles.detailItem}>
            <span style={styles.detailLabel}>Subscription Start:</span>
            <span style={styles.detailValue}>{formatDate(statusData.subscriptionStartDate)}</span>
          </div>
          <div style={styles.detailItem}>
            <span style={styles.detailLabel}>Subscription End:</span>
            <span style={styles.detailValue}>{formatDate(statusData.subscriptionEndDate)}</span>
          </div>
        </div>
        
        {statusData.services && statusData.services.length > 0 && (
          <div>
            <h3 style={{marginTop: '20px', fontSize: '18px'}}>Registered Services</h3>
            <div style={styles.servicesContainer}>
              {statusData.services.map((service, index) => (
                <div key={index} style={styles.servicesBadge}>
                  {service.serviceName} ({service.category})
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div style={styles.progressTracker}>
        <div style={styles.progressContainer}>
          <div style={styles.progressLine}>
            <div style={{...styles.progressActive, width: progress.width}}></div>
          </div>
          
          <div style={styles.progressStep}>
            <div style={{...styles.progressDot, ...styles.progressDotComplete}}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            <span style={{...styles.progressLabel, ...styles.progressLabelActive}}>Registration Submitted</span>
          </div>
          
          <div style={styles.progressStep}>
            <div style={{
              ...styles.progressDot, 
              ...(progress.step >= 2 ? (statusData.businessStatus === 'REJECTED' ? styles.progressDotActive : styles.progressDotComplete) : {})
            }}>
              {progress.step >= 2 && statusData.businessStatus !== 'REJECTED' ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              ) : progress.step >= 2 ? '!' : '2'}
            </div>
            <span style={{
              ...styles.progressLabel, 
              ...(progress.step >= 2 ? styles.progressLabelActive : {})
            }}>Processing</span>
          </div>
          
          <div style={styles.progressStep}>
            <div style={{
              ...styles.progressDot, 
              ...(progress.step >= 3 ? styles.progressDotComplete : {})
            }}>
              {progress.step >= 3 ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              ) : '3'}
            </div>
            <span style={{
              ...styles.progressLabel, 
              ...(progress.step >= 3 ? styles.progressLabelActive : {})
            }}>Active</span>
          </div>
        </div>
      </div>

      <div style={styles.supportSection}>
        <h3 style={styles.supportTitle}>Need Help?</h3>
        <p style={styles.supportText}>
          {statusData.businessStatus === 'SUCCESSFUL' 
            ? 'If you need assistance with your account or have questions about your services, our support team is ready to help.' 
            : 'If you have questions about your registration status or need assistance, please contact our support team.'}
        </p>
        
        <div style={styles.contactMethods}>
          <div style={styles.contactMethod}>
            <span style={styles.contactIcon}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </span>
            0(+233) 50-156-6333
          </div>
          <div style={styles.contactMethod}>
            <span style={styles.contactIcon}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </span>
            support@geniemarketplaces.com
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorStatusPage;